'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Color = require('../core/Color');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Style = require('../core/Style');

var _colors = require('HubStyleTokens/colors');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DETACHED_OFFSET = 40;

var getOffset = (0, _styledComponents.css)(['right:', ';top:', ';'], (0, _Style.remCalc)(DETACHED_OFFSET), (0, _Style.remCalc)(DETACHED_OFFSET));

var getDetachedStyle = function getDetachedStyle(hovered, size) {
  return (0, _styledComponents.css)(['@media only screen and (min-width:50em){color:', ';position:absolute;', ';&::after{background:', ';}}'], hovered && _colors.MONOLITH, size === 'xl' && getOffset, (0, _Color.rgba)(_colors.OLAF, 0.1));
};

var CloseButton = (0, _styledComponents2.default)(function (props) {
  var __detached = props.detached,
      rest = _objectWithoutProperties(props, ['detached']);

  return _react2.default.createElement(_UICloseButton2.default, rest);
}).withConfig({
  displayName: 'UIDialogCloseButton__CloseButton'
})(['', ';'], function (props) {
  return props.detached && getDetachedStyle(props.hovered, props.size);
});

var UIDialogCloseButton = _react2.default.createClass({
  displayName: 'UIDialogCloseButton',

  propTypes: {
    detached: _react.PropTypes.bool.isRequired,
    size: _UICloseButton2.default.propTypes.size
  },

  getDefaultProps: function getDefaultProps() {
    return {
      detached: false
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        detached = _props.detached,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['className', 'detached', 'size']);

    var computedSize = detached && size == null ? 'xl' : size;
    return _react2.default.createElement(CloseButton, _extends({
      className: (0, _classNames2.default)('uiDialog-closeButton', 'private-modal__control', 'private-modal__close', className)
    }, rest, {
      detached: detached,
      size: computedSize
    }));
  }
});

exports.default = (0, _Hoverable2.default)(UIDialogCloseButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/dialog/UIDialogCloseButton.js
// module id = 201
// module chunks = 171